module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filter_report":"Filter report"},"id":{"filter_report":"Filter laporan"}}')
  delete Component.options._Ctor
}
